import React from 'react';
import { motion } from 'framer-motion';
export function CollectionSection() {
  const books = [{
    tomo: 'TOMO 1',
    title: 'A Seguridad digital para personas comunes',
    desc: 'Las bases que todos deberían conocer.'
  }, {
    tomo: 'TOMO 2',
    title: 'A Recuperación de cuentas hackeadas',
    desc: 'Cómo recuperar Instagram, Gmail, WhatsApp y Facebook.'
  }, {
    tomo: 'TOMO 3',
    title: 'A Cómo borrar tu información de internet',
    desc: 'Reduce tu huella digital y protege tu privacidad.'
  }, {
    tomo: 'TOMO 4',
    title: 'A Cómo evitar estafas y phishing',
    desc: 'Aprende a detectar los engaños más usados.'
  }, {
    tomo: 'TOMO 5',
    title: 'A Cómo proteger tu negocio de Instagram',
    desc: 'Especial para emprendedores.'
  }];
  return <section className="bg-[#0B0B1A] py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-29">
      <div className="absolute top-0 right-1/3 w-[500px] h-[300px] bg-[#00D4FF] opacity-8 blur-[140px] rounded-full pointer-events-none" data-id="element-30" />
      <div className="absolute bottom-0 left-1/4 w-[400px] h-[300px] bg-[#FF00FF] opacity-8 blur-[120px] rounded-full pointer-events-none" data-id="element-31" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-32">
        <h2 className="text-3xl md:text-5xl font-extrabold text-center text-white mb-12" data-id="element-33">
          📚 Lo que incluye la colección
        </h2>

        <div className="space-y-6" data-id="element-34">
          {books.map((book, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white/5 border border-white/10 rounded-xl p-6 md:p-8 flex items-start gap-4 hover:bg-white/10 transition-colors" data-id="element-35">
              <span className="text-4xl flex-shrink-0" data-id="element-36">📘</span>
              <div data-id="element-37">
                <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-38">
                  <span className="text-[#00D4FF] mr-2" data-id="element-39">{book.tomo}</span>
                  {book.title}
                </h3>
                <p className="text-lg text-gray-400" data-id="element-40">{book.desc}</p>
              </div>
            </motion.div>)}
        </div>

        {/* Video Showcase */}
        <div className="mt-20 max-w-4xl mx-auto" data-id="element-41">
          <h3 className="text-2xl md:text-4xl font-extrabold text-center text-white mb-8" data-id="element-42">
            Un vistazo por dentro de la colección 👀
          </h3>
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative rounded-2xl overflow-hidden border-2 border-[#FF00FF]/40 shadow-[0_0_50px_rgba(255,0,255,0.2)] bg-black aspect-video" data-id="element-43">
            <video src="https://cdn.magicpatterns.com/uploads/ntUyRqcmuVcw7SYcaZcnft/Grabación de pantalla 2026-03-04 212300.mp4" autoPlay loop muted playsInline controls className="w-full h-full object-cover" data-id="element-44" />
          </motion.div>
        </div>
      </div>
    </section>;
}